import { AxiosResponse } from "axios";
import { apiNode } from "./api";
import {
	ChangeGroupDataProps,
	DefaultGroupParamsProps,
	GetGroupDataResponse,
	MoveItemsDataParamsProps
} from "./types/group.interfaces";

const URL = "2/groups/v2/groups";

export const GroupService = {
	async create({ data }: { data: ChangeGroupDataProps }) {
		return await apiNode.post(`${URL}/create`, data);
	},
	async rename({
		data,
		id
	}: {
		data: { name: string };
		id: string;
	}) {
		return await apiNode.patch(`${URL}/${id}/rename`, data);
	},
	async delete({ id }: DefaultGroupParamsProps) {
		return await apiNode.delete(`${URL}/${id}/delete`);
	},

	async get({
		id
	}: DefaultGroupParamsProps): Promise<GetGroupDataResponse> {
		const response: AxiosResponse<GetGroupDataResponse> =
			await apiNode.get<GetGroupDataResponse>(`${URL}/${id}`);
		return response.data;
	},
	//
	async updateGroupItems({
		items,
		id
	}: {
		items: { id: string; type: number }[];
		id: string;
	}) {
		return await apiNode.put(`${URL}/${id}/items`, items);
	},

	async moveItems({
		data,
		destinationGroupId
	}: {
		data: MoveItemsDataParamsProps;
		destinationGroupId: string | null;
	}) {
		return await apiNode.post(`${URL}/${destinationGroupId}/items/move`, data);
	},

	async deleteUser({
		userId,
		id
	}: {
		userId: string;
		id: string;
	}) {
		return await apiNode.delete(`${URL}/${id}/users/${userId}`);
	}
};
